module.exports = __webpack_public_path__ + "img/LogoDashboard-24.8df786cd.svg";